<div class="capacity-chart" #chartElem (mouseleave)="onChartMouseLeave()"> </div>

<div class="no-data" *ngIf="hasNoData"> No data available </div>
